module.exports = __webpack_public_path__ + "img/main_logo.f6781d6f.png";